import React from "react";
import DSDModuleSubtopic from "../DSDModuleSubtopic";

const NandNorImplementation = () => (
  <DSDModuleSubtopic
    title="NAND and NOR Implementation"
    videos={[
      "https://www.youtube.com/embed/4-kCfYGZDtE",
      "https://www.youtube.com/embed/-RCPJV0oOD0",
      "https://www.youtube.com/embed/GZ8V3M6PXkg"
    ]}
    takeaways={[
      { text: "Practice as many problems as possible and remember the basics from this topic" }
    ]}
    questions={[
      {
        text: "Simplify the following Boolean expression using Theorems and Postulates a) F(A,B,C) = m(1,2,3,6,7) and implement using NAND Gate b) G(A,B,C) = ∏ M(0,1,2,3) and implement using NOR Gate"
      },
      {
        text: "Minimize the Boolean function F(A,B,C,D)= ∑ m (0,1,3,5,8,11) + ∑ dm (2,7,10,15) using K Map in both SOP as well as POS forms and implement using only NAND gates"
      },
      {
        text: "Implement the following function using NOR and NAND logic gates f(a,b,c,d) = ∏ M (1,2,3,5,6,7,8,9,12,13)"
      },
      {
        text: "Simplify the Boolean Expression Y=(AB+C+D)(C'+D)(C'+D+E) by Theorem and Postulates b) Reduce the Boolean Expression F(p,q,r,s)= ∏ M (0,1,3,5,9) Design the function Y(A,B,C,D) and F(p,q,r,s) using NAND Gates alone"
      },
      {
        text: "Convert the following function to canonical POS Form F(L,M,N)=(L+M')(M+N)(L+N') b) Convert the following function to canonical SOP Form F(X,Y,Z)=X+Y'Z Design the function F(L,M,N) and F(X,Y,Z) using NAND Gates alone"
      },
      {
        text: "Implement the following function using NOR gates only F(x,y,z) = ∑ m (2,3,5,7)"
      },
      {
        text: "Simplify the Boolean function F. Implement the minimal SOP using NAND only gates and POS using NOR only gates F(w,x,y,z)= ∑ (1,3,7,8,11,15) with don’t care d(w,x,y,z) = ∑ (0,2,5,9,10)"
      },
      {
        text: "Simplify the following Boolean expression to standard SOP and POS. Implement the following simplified Boolean expression using NAND Gate and NOR Gate Circuits F(A,B,C,D)= ∑ m (5,6,7,8,11)"
      },
      {
        text: "Write the Boolean Equation for the circuits of the Figure. Use De Morgan's theorem and Boolean Algebra rules to simplify the equation. Draw the simplified circuit using only NAND Gates",
        image:"/dsd_1.png"
      }
    ]}
    exampleVideos={[]}
  />
);

export default NandNorImplementation;
